module.exports = __webpack_public_path__ + "f7eb3e1ff6150144fe02d3ed5f68dea8.png";